module.exports = __webpack_public_path__ + "static/media/video-placeholder.7c3ae87e.jpg";